import { BotSetValue, IBotData } from '../models';
import { useEffect, useRef } from 'react';

export const useFormChangeCleanup = (
  botData: IBotData,
  setValue: BotSetValue,
  resetUI: () => void,
) => {
  const previousRef = useRef('');

  useEffect(() => {
    const serialized = JSON.stringify({
      ...botData,
      tunnels: botData.tunnels.map((t) => ({
        ...t,
        sections: t.sections.map(({ error, ...rest }) => rest),
      })),
      tag: undefined
    });
    if (previousRef.current && previousRef.current !== serialized) {
      resetUI();
      setValue((draft) => {
        draft.tunnels.forEach((tunnel) => {
          tunnel.sections.forEach((section, i) => {
            if (section.error) {
              tunnel.sections[i] = { ...section, error: undefined };
            }
          });
        });
      });
    }

    previousRef.current = serialized;
  }, [botData, setValue, resetUI]);
};
